import { useState } from "react";
import { cn } from "@/lib/cn";
import { trpc } from "@/lib/trpc";
import { ContasAPagar } from "./ContasAPagar";
import { CustosFixos } from "./CustosFixos";
import { FolhaDoMes } from "./FolhaDoMes";

type Parte = "contas" | "fixos" | "folha";

export function APagar({ competencia }: { competencia: string }) {
  const [escolhida, setParte] = useState<Parte>("contas");
  // A folha do mês é do DRE ligado (é ela que alimenta Pessoal e a provisão de 13º e férias).
  const dreLigado = !!trpc.financeiro.configFinanceira.ler.useQuery().data?.dreLigado;
  const partes: { chave: Parte; rotulo: string }[] = [
    { chave: "contas", rotulo: "Contas" },
    { chave: "fixos", rotulo: "Custos fixos" },
    ...(dreLigado ? [{ chave: "folha" as const, rotulo: "Folha do mês" }] : []),
  ];
  const parte = partes.some((p) => p.chave === escolhida) ? escolhida : "contas";
  return (
    <div className="space-y-4">
      <div className={cn("inline-grid gap-1 rounded-lg bg-zinc-100 p-1 dark:bg-muted", partes.length === 3 ? "grid-cols-3" : "grid-cols-2")}>
        {partes.map((p) => (
          <button
            key={p.chave}
            type="button"
            onClick={() => setParte(p.chave)}
            className={cn(
              "whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-semibold sm:px-4",
              parte === p.chave ? "bg-white text-zinc-900 shadow-sm dark:bg-card dark:text-foreground" : "text-zinc-500 dark:text-muted-foreground",
            )}
          >
            {p.rotulo}
          </button>
        ))}
      </div>
      {parte === "contas" && <ContasAPagar competencia={competencia} />}
      {parte === "fixos" && <CustosFixos />}
      {parte === "folha" && <FolhaDoMes competencia={competencia} />}
    </div>
  );
}
